module.exports = {
  // 应用id
  appId: '90042',

  title: '运价中台',

  hostDomain: 'geekyum'
}
